import { useRef } from 'react'

export function usePaymentsRedirect(isFreedomPay: boolean) {
  const hasRedirected = useRef(false)
  if (isFreedomPay && !hasRedirected.current) {
    hasRedirected.current = true
    const freedomPayRedirectUrl = getFreedomPayRedirectUrl()
    if (freedomPayRedirectUrl) {
      window.location.host = freedomPayRedirectUrl
    }
  }
}

function getFreedomPayRedirectUrl() {
  switch (window.location.hostname) {
    case 'www.sevenrooms.com':
      return 'fp.sevenrooms.com'
    case 'eu.sevenrooms.com':
      return 'fp.eu.sevenrooms.com'
    case 'demo.sevenrooms.com':
      return 'fp.demo.sevenrooms.com'
    case 'qa.sevenrooms.com':
      return 'fp.qa.sevenrooms.com'
    default:
      return undefined
  }
}
